import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { TextField, Button, CircularProgress, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

import { successLogin, changePassword } from 'redux/auth/actions'
import { login } from 'services/apiAuth'
import { isNetworkError } from 'utils/functions'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'

import styles from './styles'
import { AuthStates, getUserTokenState, Scopes } from "../../utils/authUtils"

const Login = () => {
  const classes = styles()
  const dispatch = useDispatch()
  const history = useHistory()

  const accessToken = useSelector((state) => state.auth.access_token)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (argEmail, argPassword) => {
    setLoading(true)

    try {
      const formData = new FormData()
      formData.append('username', argEmail)
      formData.append('password', argPassword)

      const res = await login(formData)
      if (res.status === 302) {
        dispatch(
          changePassword({
            email: argEmail,
            changePasswordSession: res.data.session,
          }),
        )

        return history.push('/password-change')
      }

      const userData = res.data

      if (userData) {
        dispatch(successLogin({ ...userData }))
      }

      return false
    } catch (err) {
      setLoading(false)
      if (!isNetworkError(err)) {
        const messageError =
          _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao fazer login'
        toast.error(messageError)
      }

      return null
    }
  }

  const onEnterPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      return handleSubmit(email, password)
    }
    return false
  }

  useEffect(() => {
    if (getUserTokenState(accessToken, [Scopes.ACCESS]) === AuthStates.AUTHORIZED) {
      history.push(ROUTE_CONSTANTS.HOME)
    }
  }, [accessToken])
  
  return (
    <div className={classes.root}>
      <div className={classes.sideTriangle} />
      <aside className={classes.aside}>
        <h1>
          <img
            src="assets/images/logos/client_logo.png"
            alt="Logo"
            className={classes.logo}
          />
        </h1>
        <div style={{ marginBottom: 50 }}>
          <h1 style={{ fontSize: 50 }}>Acesso</h1>
          <p style={{ fontSize: 18 }}>
            Digite seus dados de acesso à plataforma
          </p>
        </div>
      </aside>
      <main className={classes.main}>
        <h1 className={classes.title}>Know Your Employee</h1>
        <div className={classes.inputsContainer}>
          <form className={classes.formContainer}>
            <TextField
              variant="standard"
              id="email"
              label="E-mail"
              className={classes.textField}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required={true}
              autoCorrect="off"
              autoCapitalize="off" />
            
            <TextField
              variant="standard"
              id="password"
              label="Senha"
              className={classes.textField}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={onEnterPress}
              autoComplete="off"
              type="password"
              required={true}
              autoCorrect="off"
              autoCapitalize="off" />
          </form>
          
          <Typography className={classes.link}>
            <Link to={ROUTE_CONSTANTS.FORGOT_PASSWORD}>Esqueci a senha</Link>
          </Typography>
        </div>

        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={() => handleSubmit(email, password)}
            disabled={!!loading}
          >
            {loading ? (
              <CircularProgress className={classes.progress} />
            ) : (
              'Acessar'
            )}
          </Button>
        </div>
      </main>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(Login)
